/* eslint-disable @nx/enforce-module-boundaries */
import {
  Box,
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Container,
  HStack,
  Heading,
  Stack,
  Text,
  VStack,
  Circle,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from '@mybridge/ui';
import React, { useEffect,useState } from 'react';
import Head from 'next/head';
import { useDispatch, useSelector } from 'react-redux';
import { getStaticPageContent } from 'v4/store/actions/global.data.actions';
import { setOpenAuthModal } from 'v4/store/actions/auth.actions';
import Image from 'next/image';
import Link from 'next/link';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useRouter } from 'next/router';
import { ForceSignInWrapper } from 'v4/components/force-sign-in-wrapper';
const AboutPage = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { t } = useTranslator();
  const { pageContetStatic } = useSelector((state) => state.globalData);
  const { loggedIn } = useSelector((state) => state.user);
  // useEffect(() => {
  //   dispatch(getStaticPageContent('about-us'));
  // }, []);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // useEffect(() => {
  //   dispatch(getStaticPageContent('about-us'));
  // }, [dispatch]);

  // Function to handle button click
  // const handleExploreClick = () => {
  //   setIsModalOpen(true);
  // };

  const handleExploreClick = () => {
    if (loggedIn) {
      isMobile ? setIsModalOpen(true) : router.push('/campaign');
    } else {
      dispatch(setOpenAuthModal('sign-in'));
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <Head>
        <title>{t('aboutPage.title') || "Business - mybridge"}</title>
        <meta
          name="description"
          content="myBridge.me is a professional Social networking site for professionals of various backgrounds. myBridge was created exclusively for business professionals like you to bridge the gap between where you are in your career and where you want to go."
        />
        <meta
          name="keywords"
          content="Professional networking platform , Video chat & Livestream, Create and organize team, Keep your team connected, Free job search sites,  USA, Usa job sites, Job search engines, Online calendar for your business, Event listing websites, FREE USA Online Chat"
        />
      </Head>

      <section>
        <Box display="block" className="businessBanner" py={["10px", "100px"]}>
           <Container maxW={["108%", "90%", "1300px"]} w={["108%","100%"]}>
            <Stack
              direction={['column', 'row']}
              spacing="24px"
              justifyContent="space-between"
            >
              <VStack alignItems="flex-start" gap={8} justifyContent="center">
                <Heading
                  as="h3"
                  color="#0894E0"
                  fontSize={["50px", "70px", "90px"]}
                  fontWeight="600"
                >
                  myBridgeAd
                </Heading>
                <VStack gap={3} mb={3} alignItems="stretch">
                  <Text
                    color="#3D5A80"
                    // fontSize="56px"
                    fontSize={["40px", "46px", "56px"]}
                    fontWeight="700"
                    lineHeight="62px"
                  >
                    {t('aboutPage.moreAudiences') || "More audiences."}
                  </Text>
                  <Text
                    color="#3D5A80"
                    fontSize={["40px", "46px", "56px"]}
                    fontWeight="700"
                    lineHeight="62px"
                  >
                    {t('aboutPage.moreResults') || "More results."}
                  </Text>
                  <Text
                    color="#3D5A80"
                    fontSize={["40px", "46px", "56px"]}
                    fontWeight="700"
                    lineHeight="62px"
                  >
                    {t('aboutPage.moreAccurately') || "More accurately."}
                  </Text>
                </VStack>
                {isMobile ? (
                  <Button
                    borderRadius="full"
                    p="9%"
                    boxShadow="none"
                    fontSize="24px"
                    fontWeight="700"
                    bg="#3D5A80"
                    color="#FFFFFF"
                    _hover={{ bg: '#3D5A80' }}
                    onClick={handleExploreClick}
                  >
                    {t('aboutPage.exploreMyBridgeAd') || "Explore myBridgeAd"}
                  </Button>
                ) : (
                  <Button
                    borderRadius="full"
                    p="31px"
                    boxShadow="none"
                    fontSize="24px"
                    fontWeight="700"
                    bg="#3D5A80"
                    color="#FFFFFF"
                    _hover={{ bg: '#3D5A80' }}
                    onClick={handleExploreClick}
                  >
                    {t('aboutPage.exploreMyBridgeAd') || "Explore myBridgeAd"}
                  </Button>
                )}
              </VStack>
              <VStack>
                <Image
                  src="/images/myBridgeBannerImage.png"
                  width="540"
                  height="640"
                  alt="myBridgeAd"
                  loading='lazy'
                />
              </VStack>
            </Stack>
          </Container>
        </Box>
      </section>
      <section>
        <Box py="100px" bg="#ffffff" justifyContent="center">
          <Container maxW={["108%", "90%", "100%"]} w={["108%","100%"]}>
            <VStack gap={4} mb={8}>
              <Heading
                as="h4"
                color="#004680"
                fontSize="70px"
                fontWeight="700"
                textAlign="center"
              >
                {t('aboutPage.createMyBridgePage') || "Create a mybridge page"}
              </Heading>
              <Text
                color="#333333"
                fontSize="40px"
                fontWeight="500"
                textAlign="center"
              >
                {t('aboutPage.connectWithCommunity') || "Connect with clients, employees, and the myBridge community."}
              </Text>
              <Flex gap={12} justifyContent="center" py="2%">
                <Box
                  bg="#EBF2FF"
                  borderRadius="30px"
                  boxShadow="none"
                  w={["90%", "450px"]}
                  minH="310px"
                >
                  <VStack gap={4} p={6} justifyContent="center" h="100%">
                    <Image
                      src="/images/Office_building_icon.png"
                      width="150"
                      height="150"
                      alt="myBridgeAd"
                      loading='lazy'
                    />
                    <Text
                      fontSize="26px"
                      fontWeight="700"
                      color="#004680"
                      textAlign="center"
                    >
                      {t('aboutPage.smallMediumLargeBusiness') || "Small, medium, and large businesses"}
                    </Text>
                  </VStack>
                </Box>
                <Box
                  bg="#EBF2FF"
                  borderRadius="30px"
                  boxShadow="none"
                  w={["90%", "450px"]}
                  minH="310px"
                >
                  <VStack gap={4} p={6} justifyContent="center" h="100%">
                    <Image
                      src="/images/School.png"
                      width="150"
                      height="150"
                      alt="myBridgeAd"
                      loading='lazy'
                    />
                    <Text
                      fontSize="26px"
                      fontWeight="700"
                      color="#004680"
                      textAlign="center"
                    >
                      {t('aboutPage.schoolsAndUniversities') || "Schools and universities"}
                    </Text>
                  </VStack>
                </Box>
              </Flex>
              <ForceSignInWrapper>
              <Link href="/page/create">
                <Button
                  borderRadius="full"
                  p="15%"
                  bg="#3D5A80"
                  boxShadow="none"
                  color="white"
                  fontSize="24px"
                  fontWeight="700"
                  _hover={{ bg: '#3D5A80' }}
                >
                  {t('createPage.createPage') || "Create a Page"}
                </Button>
              </Link>
              </ForceSignInWrapper>
            </VStack>
            <Stack
              direction={['column', 'row']}
              spacing="24px"
              justifyContent="center"
              alignItems="stretch"
            >
              <VStack alignItems="flex-start">
                <Image
                  src="/images/createPagePreview.png"
                  width="1261"
                  height="709"
                  alt="myBridgeAd"
                  loading='lazy'
                />
              </VStack>

            </Stack>
          </Container>
        </Box>
      </section>
      <section>
        <Box py="100px">
          <Container maxW={["108%", "90%", "1366px"]} w={["108%","100%"]}>
            <Stack
              direction={['column', 'row']}
              spacing="24px"
              justifyContent="space-between"
            >
              <VStack alignItems="flex-start" gap={4} flex="1">
                <Heading
                  as="h4"
                  color="#3D5A80"
                  fontSize="48px"
                  fontWeight="600"
                >
                  {t('aboutPage.findPerfectEmployee') || "Find Your Perfect Employee"}
                </Heading>
                <Text fontSize="24px" color="#666666">
                  <span color='#666666' fontWeight="500">{t('aboutPage.postingJobEnsures') || "Posting a job on myBridge ensures you will reach modern business professionals who are eager to find that new position to elevate their careers."}</span> {t('aboutPage.inclusiveCommunity') || "Our online community is inclusive of those wanting to build their business network and be social at the same time."}
                </Text>
                <Text fontSize="24px" color="#666666">
                  {t('aboutPage.wideRangeCandidates') || "With a wide range of candidates looking to reach their career goals on this new platform, your job posting will be seen by those active job seekers looking for a superior job search experience."}
                </Text>
                <ForceSignInWrapper>
                <Link href="/page/jobs/create">
                  <Button
                    borderRadius="full"
                    bg="#3D5A80"
                    p="15%"
                    boxShadow="none"
                    color="white"
                    fontSize="22px"
                    fontWeight="700"
                    _hover={{ bg: '#3D5A80' }}
                  >
                    {t('aboutPage.postFirstJob') || "Post your first job"}
                  </Button>
                </Link>
                </ForceSignInWrapper>
              </VStack>
              <VStack flex="1" alignItems="flex-end">
                <Image
                  src="/images/find_employee.svg"
                  width="690"
                  height="690"
                  alt="myBridgeAd"
                  loading='lazy'
                />
              </VStack>
            </Stack>
          </Container>
        </Box>
      </section>
      <section>
        <Box py="100px">
          <Container maxW={["108%", "90%", "1366px"]} w={["108%","100%"]}>
            <VStack gap={4} mb={8}>
              <Heading
                as="h4"
                color="#004680"
                fontSize="70px"
                fontWeight="700"
                textAlign="center"
              >
                {t('aboutPage.postFirstJobSteps') || "Post your first job in 3 easy steps"}
              </Heading>
              <Text
                color="#333333"
                fontSize="40px"
                fontWeight="500"
                textAlign="center"
              >
                {t('aboutPage.notActiveUser') || "Not an active user on myBridge? Follow these three easy steps to create your first job posting."}
              </Text>
            </VStack>
          </Container>
          <Container maxW={["108%", "90%", "100%"]} w={["108%","100%"]}>
            <Stack gap="24px" direction={['column', 'row']} justifyContent="space-evenly">
              <Card
                bg="#3D5A80"
                boxShadow="6px 20px 20px 0px #0000004D"
                borderRadius="16px"
                maxW="430px"
              >
                <Image
                  src="/images/job-step1.png"
                  width="430"
                  height="290"
                  alt="myBridgeAd"
                  loading='lazy'
                />
                <HStack mt="-30px" w="100%" justifyContent="center">
                  <Circle bg="white" w="60px" h="60px">
                    <Text color="#3D5A80" fontSize="30px" fontWeight="800">
                      1
                    </Text>
                  </Circle>
                </HStack>
                <CardBody>
                  <Text
                    fontSize="30px"
                    fontWeight="600"
                    color="white"
                    mb={3}
                    lineHeight="37px"
                  >
                    {t('aboutPage.step1Title') || "Create a personal profile on our platform."}
                  </Text>
                  <Text fontSize="20px" fontWeight="400" color="white" mb={3}>
                    {t('aboutPage.step1Description') || "We ensure every job comes from an actual, real-live person. Every job you see comes from legitimate sources."}
                  </Text>
                  <Text fontSize="20px" fontWeight="600" color="white">
                    {t('aboutPage.alreadyHaveProfile') || "Already have a myProfile? Sign in here."}
                  </Text>
                </CardBody>
              </Card>
              <Card
                bg="#3D5A80"
                boxShadow="6px 20px 20px 0px #0000004D"
                borderRadius="16px"
                maxW="430px"
              >
                <Image
                  src="/images/createPageImage.png"
                  width="430"
                  height="290"
                  alt="myBridgeAd"
                  loading='lazy'
                />
                <HStack mt="-30px" w="100%" justifyContent="center">
                  <Circle bg="white" w="60px" h="60px">
                    <Text color="#3D5A80" fontSize="30px" fontWeight="800">
                      2
                    </Text>
                  </Circle>
                </HStack>
                <CardBody minH="258px">
                  <Text
                    fontSize="30px"
                    fontWeight="600"
                    color="white"
                    mb={3}
                    lineHeight="37px"
                  >
                    {t('createPage.createPage') || "Create a Page"}
                  </Text>
                  <Text fontSize="20px" fontWeight="400" color="white" mb={3}>
                    {t('aboutPage.step2Description') || "A Page is where your company will be showcased on our platform. Here you can add team members and manage your job postings."}
                  </Text>
                </CardBody>
              </Card>
              <Card
                bg="#3D5A80"
                boxShadow="6px 20px 20px 0px #0000004D"
                borderRadius="16px"
                maxW="430px"
              >
                <Image
                  src="/images/post-job-image.png"
                  width="430"
                  height="290"
                  alt="myBridgeAd"
                  loading='lazy'
                />
                <HStack mt="-30px" w="100%" justifyContent="center">
                  <Circle bg="white" w="60px" h="60px">
                    <Text color="#3D5A80" fontSize="30px" fontWeight="800">
                      3
                    </Text>
                  </Circle>
                </HStack>
                <CardBody minH="258px">
                  <Text
                    fontSize="30px"
                    fontWeight="600"
                    color="white"
                    mb={3}
                    lineHeight="37px"
                  >
                    {t('aboutPage.step3Title') || "List your job"}
                  </Text>
                  <Text fontSize="20px" fontWeight="400" color="white" mb={3}>
                    {t('aboutPage.step3Description') || "Creating a new job posting using our dashboard is quick and easy because of our pre-set tabs and intuitive workflow."}
                  </Text>

                </CardBody>
              </Card>
            </Stack>
          </Container>
        </Box>
      </section>
      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <ModalOverlay />
        <ModalContent width="80%" p="5%">
          <ModalCloseButton fontSize="sm"/>
          <ModalBody>
            <Text fontWeight="700" textAlign="center" fontSize="20px">{t('pages.featureOptimizedForDesktop') || "This Feature is optimized for our desktop site."}</Text>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AboutPage;
